import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      style={{
        backgroundColor: "#111",
        color: "#ddd",
        padding: "50px 20px 30px",
        borderTop: "3px solid #00a082",
        marginTop: "50px",
        fontFamily: "Inter, sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: 1200,
          margin: "0 auto",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          gap: 40,
        }}
      >
        {/* Left column */}
        <div
          style={{
            flex: "1 1 200px",
            minWidth: 200,
            textAlign: "left",
          }}
        >
          <h4 style={headingStyle}>LunGO Platform</h4>
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            <li><Link to="/privacy" style={linkStyle}>Privacy Policy</Link></li>
            <li><Link to="/terms" style={linkStyle}>Terms & Conditions</Link></li>
            <li><Link to="/faq" style={linkStyle}>FAQ</Link></li>
            <li><Link to="/contact-us" style={linkStyle}>Contact Us</Link></li>
            <li><Link to="/become-a-partner" style={linkStyle}>Become a Partner</Link></li>
          </ul>
        </div>

        {/* Center column */}
        <div
          style={{
            flex: "1 1 200px",
            minWidth: 200,
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span style={{ fontSize: 14, color: "#bbb" }}>Made with ❤️ in Poland</span>
        </div>

        {/* Right column */}
        <div
          style={{
            flex: "1 1 200px",
            minWidth: 200,
            textAlign: "right",
          }}
        >
          <h4 style={{ ...headingStyle, textAlign: "right" }}>Follow Us</h4>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 8,
              alignItems: "flex-end",
            }}
          >
            <a href="https://facebook.com" target="_blank" rel="noreferrer" style={linkStyle}>Facebook</a>
            <a href="https://instagram.com" target="_blank" rel="noreferrer" style={linkStyle}>Instagram</a>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer" style={linkStyle}>LinkedIn</a>
          </div>
        </div>
      </div>

      {/* Bottom note */}
      <div
        style={{
          textAlign: "center",
          marginTop: 40,
          color: "#aaa",
          fontSize: 13,
          borderTop: "1px solid #222",
          paddingTop: 15,
        }}
      >
        © {new Date().getFullYear()}{" "}
        <span style={{ color: "#00a082", fontWeight: 600 }}>LunGO</span>. All rights reserved.
      </div>
    </footer>
  );
}

const headingStyle = {
  fontSize: 16,
  fontWeight: 600,
  marginBottom: 12,
  color: "#fff",
};

const linkStyle = {
  color: "#ddd",
  textDecoration: "none",
  fontSize: 14,
  display: "block",
  marginBottom: 6,
  transition: "color 0.2s ease",
};

const infoStyle = {
  margin: "4px 0",
  fontSize: 14,
  color: "#ccc",
};
